module.exports = __webpack_public_path__ + "img/save-the-world.de8b9090.webp";